import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
});

// Fallback: if login response returned a token, attach it as Bearer for cross-site fetches
let bearerToken = null;
try {
  bearerToken = localStorage.getItem("jb_token");
} catch (_) {}

export function setBearerToken(token) {
  bearerToken = token || null;
  try {
    if (token) localStorage.setItem("jb_token", token);
    else localStorage.removeItem("jb_token");
  } catch (_) {}
}

api.interceptors.request.use((config) => {
  if (bearerToken) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${bearerToken}`;
  }
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
  return url;
}
